import {OrganizationClient} from "../types/models/OrganizationClient";
import {INotificationsStore} from "./NotificationsStore";
import {makeAutoObservable, runInAction} from "mobx";
import {AxiosInstance} from "axios";
import {IResult} from "../services/Result";
import {OrganizationClientsResponse} from "../types/models/OrganizationClientsResponse";
import {AxiosResponseHelper} from "../utilities/AxiosResponseHelper";
import {t} from "../utilities/TranslationUtils";

export class ClientsStore {
  clients: OrganizationClient[] = [];
  idPrefix: string;
  isLoadingData: boolean = false;
  isAddingClient: boolean = false;
  loadError: string | null = null;

  _notificationStore: INotificationsStore

  constructor(notificationStore: INotificationsStore) {
    this._notificationStore = notificationStore
    makeAutoObservable(this);
  }

  public async LoadData(apiInstance: AxiosInstance) {
    runInAction(() => { 
      this.isLoadingData = true;
      this.loadError = null;
    })
    try {
      let response = await apiInstance.get<IResult<OrganizationClientsResponse>>('api/Clients');
      if (AxiosResponseHelper.IsSuccessfulResponse(response) && response.data.data) {
        const data = response.data.data;
        runInAction( () => {
          this.clients = data.clients;
          this.idPrefix = data.idPrefix;
        });
      } else {
        runInAction(() => {
          this.loadError = t('toastMessages.clientsLoadFailed');
        });
        this._notificationStore.displayNotification({
          response: response.data,
          variant: 'error',
          title: t('common.error'),
          message: t('toastMessages.clientsLoadFailed'),
        });
      }
    } catch (error) {
      runInAction(() => {
        this.loadError = t('toastMessages.clientsLoadFailed');
      });
      this._notificationStore.displayNotification({
        variant: 'error',
        title: t('common.error'),
        message: t('toastMessages.clientsLoadFailed'),
      });
    }
    runInAction(() =>  { this.isLoadingData = false });
  }
  public async AddClient(apiInstance: AxiosInstance, data: OrganizationClient, successCB: (result: string) => void, errorCB: () => void){
    runInAction(() => { this.isAddingClient = true });
    let response = await apiInstance.post('api/Clients', data);
    if (AxiosResponseHelper.IsSuccessfulResponse(response)) {
      this._notificationStore.displayNotification({
        response: response.data,
        variant: 'success',
        title: t('common.success'),
        message: t('toastMessages.clientAdded')
      });

      successCB(response.data.data)
    } else {
      this._notificationStore.displayNotification({
        response: response.data,
        variant: 'error',
        message: t('toastMessages.clientAddFailed'),
      });
      errorCB();
    }
    runInAction(() => { this.isAddingClient = false });
  }

  public async DeleteClient(apiInstance: AxiosInstance, clientId: string, sucessCB: () => void, errorCB: () => void) {
    let response = await apiInstance.delete(`api/clients/${clientId}`)
    if (AxiosResponseHelper.IsSuccessfulResponse(response)) {
      this._notificationStore.displayNotification({
        response: response.data,
        variant: 'success',
        message: t('toastMessages.clientDeleted')
      })
      sucessCB()
      await this.LoadData(apiInstance)
    } else {
      this._notificationStore.displayNotification({
        response: response.data,
        variant: 'error',
        message: t('toastMessages.clientDeleteFailed')
      })
      errorCB();
    }
  }

  public async RegenerateClientSecret(apiInstance: AxiosInstance, clientId: string, successCB: (result: string) => void, errorCB: () => void) {
    let response = await apiInstance.put(`api/clients/${clientId}/regenerate-secret`)
    if (AxiosResponseHelper.IsSuccessfulResponse(response)) {
      this._notificationStore.displayNotification({
        response: response.data,
        variant: 'success',
        message: t('toastMessages.clientSecretRegenerated')
      });
      successCB(response.data.data)
    } else {
      this._notificationStore.displayNotification({
        response: response.data,
        variant: 'error',
        message: t('toastMessages.clientSecretRegenerationFailed')
      });
      errorCB();
    }
  }
}